// extracted by mini-css-extract-plugin
module.exports = {"video":"WidgetVideo_video__1Vqqp"};